import * as React from "react";
const IconTarget = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" className="" viewBox="0 0 16 16">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="0.8"
      d="M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333ZM14.667 8H12M4 8H1.333M8 4V1.333m0 13.334V12"
    ></path>
  </svg>
);
export default IconTarget;
